import React from "react";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import Headers from "./Header";
import Sidebar from "./Sidebar";

const { Content } = Layout;

export default function ParentLayout() {
  return (
    <Layout style={{flex: 1}}>
      <Sidebar />
      <Layout style={{backgroundColor: "RGB(242, 244, 244)"}}>
        <Headers />
        <Content id="main-content-layout" style={{display: "flex", flexDirection: "column", margin: 15, backgroundColor: "RGBA(255, 255, 255, 0.8)", borderRadius: 3, position: "relative"}}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
